import cn from 'classnames'
import { SignOffAlert } from 'legacy/lut/components/widgets/public/partner360/SignOffAlert'
import React from 'react'

import { Translation } from 'cng-common/features/translations/components/translation'
import { Button } from 'core-components/library/button/Button'

import styles from './ConfirmationDialog.module.scss'

interface IDeleteDialogProps {
  text: string
  onClick: (submit: boolean) => void
  signed?: boolean
  translation?: boolean
  submitText?: string
  submitColor?: 'primary' | 'success' | 'warning' | 'danger' | 'white' | 'grey'
  cancelText?: string
  cancelButtonClassName?: string
  replaceParams?: {
    key: string
    value: string
  }[]
  htmlAvailable?: boolean
  withoutCancelSection?: boolean
}

export const ConfirmationDialog = (props: IDeleteDialogProps) => {
  return (
    <React.Fragment>
      <p className={styles.info}>
        {props.translation ? (
          <Translation
            text={props.text}
            span
            actionsInside
            replaceParams={props.replaceParams}
            htmlAvailable={props.htmlAvailable}
          />
        ) : (
          props.text
        )}
      </p>
      {props.signed && <SignOffAlert />}
      <div className={styles.line}>
        <Button
          className={styles.button}
          color={props.submitColor}
          onClick={() => props.onClick(true)}
        >
          {props.translation ? (
            <Translation text={props.submitText ? props.submitText : 'jbp-submit'} />
          ) : props.submitText ? (
            props.submitText
          ) : (
            'Submit'
          )}
        </Button>
        {!props.withoutCancelSection ? (
          <Button
            className={cn(styles.button, props.cancelButtonClassName)}
            color={!props.cancelButtonClassName ? 'danger' : undefined}
            onClick={() => props.onClick(false)}
          >
            {props.translation ? (
              <Translation text={props.cancelText ? props.cancelText : 'jbp-cancel'} />
            ) : props.cancelText ? (
              props.cancelText
            ) : (
              'Cancel'
            )}
          </Button>
        ) : null}
      </div>
    </React.Fragment>
  )
}
